import React from 'react';

import styles from './styles.module.scss';
import {
  Discord,
  Company1,
  Company2,
  Company3,
  Company4,
  Company5,
  Company6,
  LogoPrimary,
} from '../../../assets';
import {Orbit1, Icon1, Icon2, Icon3, Icon4, Icon5} from '../../../assets/icons/logo';

const iconsList = [
  {
    id: '1',
    icon: <Company1 />,
  },
  {
    id: '2',
    icon: <Company2 />,
  },
  {
    id: '3',
    icon: <Company3 />,
  },
  {
    id: '4',
    icon: <Company4 />,
  },
  {
    id: '5',
    icon: <Company5 />,
  },
  {
    id: '6',
    icon: <Company6 />,
  },
];

export const Hero = () => {
  return (
    <div className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.top}>
          <h1 className={styles.title}>
            Reach the <span className={styles.decor}>next peak</span> of security experience
          </h1>
          <p className={styles.subTitle}>
            Next generation security bot for a seamless experience of your journey
          </p>
          <div className={styles.buttons}>
            <div className={styles.buttonPrimary}>
              <Discord />
              Add to Discord
            </div>
            <div className={styles.buttonSecondary}>Documentation</div>
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.text}>Loved by folks at</div>
          <div className={styles.iconsWrapper}>
            {iconsList.map((item) => (
              <div className={styles.icon} key={item.id}>
                {item.icon}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.logo}>
        <div className={styles.orbit1}>
          <div className={styles.rotate1}>
            <Orbit1 />
          </div>
          <div className={styles.icon1}>
            <Icon1 />
          </div>
          <div className={styles.icon2}>
            <Icon2 />
          </div>
        </div>
        <div className={styles.orbit2}>
          <div className={styles.rotate2}>
            <Orbit1 />
          </div>
          <div className={styles.icon3}>
            <Icon3 />
          </div>
          <div className={styles.icon4}>
            <Icon4 />
          </div>
        </div>
        <div className={styles.orbit3}>
          <div className={styles.rotate1}>
            <Orbit1 />
          </div>
          <div className={styles.icon5}>
            <Icon5 />
          </div>
        </div>
        <div className={styles.centerLogoWrapper}>
          <div className={styles.centerLogo}>
            <LogoPrimary />
          </div>
        </div>
      </div>
      <div className={styles.heroBottomDecor}></div>
    </div>
  );
};
